import React from 'react'
import FootImageComp from './FootImageComp';

const FootSensationDiagram = (props) => {
    const { control , errors, getValues, setValue } = props;

  return (
            <FootImageComp control={control} errors={errors} getValues={getValues}/>          
  )
}

export default FootSensationDiagram